import React from 'react';

const GroupMessagesIcon = (props: any) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="32" height="32" rx="16" fill="#8A3196" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 22.3333L12.8031 24.8908C12.6547 25.0095 12.4514 25.0326 12.2802 24.9503C12.1089 24.868 12 24.6948 12 24.5048V22.3333H10.6667C9.19391 22.3333 8 21.1394 8 19.6666V11.6667C8.00001 10.1939 9.19392 9 10.6667 9H21.3333C22.8061 9 24 10.1939 24 11.6667V19.6666C24 21.1394 22.8061 22.3333 21.3333 22.3333H16Z"
      stroke={props.color || '#000'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 13.5H20"
      stroke={props.color || '#000'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17.5H20"
      stroke={props.color || '#000'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GroupMessagesIcon;
